import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="/logo-footer.png" 
                alt="ALM Group of Companies" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Excellence in Trading, Consulting & Technology. Your trusted partner for business growth and innovation.
            </p>
            <div className="flex space-x-3">
              <a href={companyInfo.socialMedia.linkedin} className="w-9 h-9 bg-secondary hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 group">
                <Linkedin size={18} className="text-muted-foreground group-hover:text-white transition-colors" />
              </a>
              <a href={companyInfo.socialMedia.twitter} className="w-9 h-9 bg-secondary hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 group">
                <Twitter size={18} className="text-muted-foreground group-hover:text-white transition-colors" />
              </a>
              <a href={companyInfo.socialMedia.facebook} className="w-9 h-9 bg-secondary hover:bg-primary rounded-lg flex items-center justify-center transition-all duration-300 group">
                <Facebook size={18} className="text-muted-foreground group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/payment" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  Make a Payment
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/trading" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  ALM Trading LLC
                </Link>
              </li>
              <li>
                <Link to="/services/consultancy" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  ALM Consultants LLC
                </Link>
              </li>
              <li>
                <Link to="/services/it-services" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  ALM IT Services
                </Link>
              </li>
              <li>
                <Link to="/services/software" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  ALM Software Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-primary mt-1 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-primary mt-1 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-primary mt-1 flex-shrink-0" />
                <span className="text-sm text-muted-foreground">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} ALM Group of Companies. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className="text-muted-foreground hover:text-primary transition-colors duration-300">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
